import axios from "axios";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Close from "../../assets/img/ExitIcon.png";
import Izjava from "../../assets/izjava.pdf";
import Pravilnik from "../../assets/pravilnik.pdf";
import Sporazum from "../../assets/sporazum.pdf";
import { useUserState } from "../../context/UserContext";

const documents = [
  {
    id: 1,
    title:
      "Sporazum Škole integralne tjelesne psihoterapije i polaznika programa",
    required: true,
    pdfUrl: Sporazum,
  },
  {
    id: 2,
    title: "Izjava polaznika kod upisa u programe Škole ITP-a",
    required: true,
    pdfUrl: Izjava,
  },
  {
    id: 3,
    title: "PRAVILNIK O POHAĐANJU PROGRAMA U ŠKOLI ITP-a",
    required: false,
    pdfUrl: Pravilnik,
  },
];

export const PrivolaModal = ({ isMyProfileClick, setApproveModal }) => {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);
  const [backBtnHovered, setBackBtnHovered] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [selectedDocId, setSelectedDocId] = useState(null);
  const [approvedDocs, setApprovedDocs] = useState([]);
  const [canApprove, setCanApprove] = useState(false);
  const iframeContainerRef = useRef(null);
  const { userData, accessToken } = useUserState();

  const handleDocClick = (id) => {
    setSelectedDocId(id);
    setCanApprove(false);
  };

  const handleScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } =
      iframeContainerRef.current;
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      setCanApprove(true);
    }
  };

  const handleApprove = () => {
    if (!approvedDocs.includes(selectedDocId)) {
      setApprovedDocs([...approvedDocs, selectedDocId]);
    }
    setSelectedDocId(null);
  };

  const selectedDoc = documents.find((doc) => doc.id === selectedDocId);
  const allRequiredApproved = documents
    .filter((doc) => doc.required)
    .every((doc) => approvedDocs.includes(doc.id));

  if (!isOpen) return null;
  return (
    <div style={styles.overlay}>
      <img
        alt="close"
        src={Close}
        style={{ ...styles.closeBtn, opacity: hovered ? 0.7 : 1 }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onClick={
          !isMyProfileClick
            ? () => navigate("/programi/one")
            : () => {
                setIsOpen(false);
                setApproveModal(false);
              }
        }
      />
      <div style={styles.modal}>
        {!selectedDoc && (
          <div>
            <h2 style={styles.title}>
              Molimo vas pregledajte i potpišite dokumente:
            </h2>
            <div style={styles.grid}>
              {documents.map((doc) => (
                <div
                  key={doc.id}
                  style={styles.docItem}
                  onClick={() => handleDocClick(doc.id)}
                >
                  <div style={styles.icon}>📄</div>
                  <div style={styles.docTitle}>{doc.title}</div>
                  {approvedDocs.includes(doc.id) && (
                    <div style={styles.check}>✔️</div>
                  )}
                  {doc.required && !approvedDocs.includes(doc.id) && (
                    <div style={styles.required}>Obavezno</div>
                  )}
                </div>
              ))}
            </div>
            <p style={styles.infoText}>
              Sporazum i Izjavu polaznika je potrebno digitalno potpisati kako
              bi se moglo pristupiti programu.
              <br />
              Klikom na “Prihvaćam” potvrđujem da sam upoznat/a s{" "}
              <b>Pravilnikom</b> i digitalno potpisujem <b>Sporazum</b> i{" "}
              <b>Izjavu</b>.
            </p>
            {allRequiredApproved && (
              <button
                style={styles.button}
                onClick={() => {
                  axios
                    .put(
                      `${process.env.REACT_APP_API_URL}/api/user/${userData.id}`,
                      {
                        didApproveTerms: true,
                      },
                      { headers: { Authorization: `Bearer ${accessToken}` } }
                    )
                    .then(() => setIsOpen(false))
                    .catch((error) => {
                      alert(
                        "Došlo je do greške prilikom spremanja privole. Pokušajte ponovno kasnije."
                      );
                    });
                }}
              >
                Prihvaćam
              </button>
            )}
          </div>
        )}

        {selectedDoc && (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            <h2 style={styles.title}>{selectedDoc.title}</h2>
            <div
              ref={iframeContainerRef}
              onScroll={handleScroll}
              style={styles.iframeContainer}
            >
              <iframe
                src={selectedDoc.pdfUrl}
                title={selectedDoc.title}
                width="100%"
                height="100%"
                style={{ border: "none" }}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "1rem",
              }}
            >
              <button
                onClick={() => setSelectedDocId(null)}
                style={{
                  ...styles.button,
                  backgroundColor: "#9fa7b2",
                  cursor: "pointer",
                  opacity: backBtnHovered ? 0.9 : 1,
                }}
                onMouseEnter={() => setBackBtnHovered(true)}
                onMouseLeave={() => setBackBtnHovered(false)}
              >
                Natrag
              </button>
              {selectedDocId !== 3 && (
                <button
                  onClick={handleApprove}
                  style={{
                    ...styles.button,
                    backgroundColor: canApprove ? "#28a745" : "#ccc",
                    cursor: canApprove ? "pointer" : "not-allowed",
                  }}
                  disabled={!canApprove}
                >
                  Digitalno potpisujem
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "#fff",
    padding: "24px",
    borderRadius: "8px",
    width: "90%",
    maxWidth: "1000px",
    maxHeight: "90vh",
    height: "100%",
    overflowY: "auto",
    boxSizing: "border-box",
  },
  closeBtn: {
    position: "absolute",
    right: "3%",
    top: "5%",
    cursor: "pointer",
    transition: "300ms ease-in-out",
  },
  title: {
    fontSize: "20px",
    fontWeight: "bold",
    marginBottom: "16px",
  },
  grid: {
    display: "flex",
    justifyContent: "space-between",
    gap: "12px",
    marginBottom: "16px",
  },
  docItem: {
    flex: "1",
    padding: "12px",
    border: "1px solid #ddd",
    borderRadius: "6px",
    textAlign: "center",
    cursor: "pointer",
  },
  icon: {
    fontSize: "32px",
    marginBottom: "8px",
  },
  docTitle: {
    fontSize: "14px",
    fontWeight: "500",
  },
  check: {
    fontSize: "16px",
    color: "green",
    marginTop: "4px",
  },
  required: {
    fontSize: "12px",
    color: "red",
    marginTop: "4px",
  },
  infoText: {
    fontSize: "14px",
    color: "#666",
    marginBottom: "16px",
  },
  button: {
    padding: "10px 20px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "4px",
    alignSelf: "flex-end",
    fontSize: "14px",
  },
  iframeContainer: {
    height: "70vh",
    overflowY: "auto",
    border: "1px solid #ccc",
    borderRadius: "4px",
  },
};
